export default __webpack_public_path__ + "static/media/chatVoice.93666a7c.svg";